import { render, staticRenderFns } from "./AddressTableRow.vue?vue&type=template&id=5243487d"
import script from "./AddressTableRow.vue?vue&type=script&lang=ts"
export * from "./AddressTableRow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports